import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Services.css';


function Services() {
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  const services = [
    {
 
  title: 'Plateau Konnect',
  description: "We boost developers' growth with creative marketing and a skilled team",
  image: '/Plateau konnect icon.png',
  path: 'https://www.konnect.propertyplateau.com/' // Removed the extra '/' at the beginning

    },
    {
      title: 'Lease with Us',
      description: 'Rent with us for a seamless journey where convenience meets comfort',
      image: '/Lease with us icon.png',
      path: '/Lease-with-us'
    },
    {
      title: 'Invest in Real Estate',
      description: 'Home is where the heart is. Let us guide you there.',
      image: '/Invest in real estate icon.png',
      path: '/Invest-real'
    },
    {
      title: 'Sell your home',
      description: 'Sell your home with style, fetch a price that smiles!',
      image: '/Sell your house icon.png',
      path: '/sell-your-home'
    },
    {
      title: 'Vastu Consultation',
      description: 'Elevate life with Vastu guidance, harmonize your space, feel the difference!',
      image: '/Vastu consultation icon.png',
      path: '/vastu-consultation'
    },
    {
      title: 'Home Interior',
      description: 'Admire worthy designs, wallet-friendly prices, indulge in affordable elegance!',
      image: '/House interior icon.png',
      path: '/Home-interiror'
    },
    {
      title: 'Painting Services',
      description: 'Interior and Exterior painting services we offer',
      image: '/Painting services icon.png',
      path: '/painting-services'
    },
    {
      title: 'NRI Guide',
      description: 'Welcome to a world of possibilities for NRIs - let us be your compass!',
      image: '/NRI guide icon.png',
      path: '/NRI-guide'
    },
    {
      title: 'Facility Management',
      description: 'Precise Management, Personalized Service: Your Facility, Our Focus',
      image: '/Facility management icon.png',
      path: '/Facility-management'
    },
    {
      title: 'Construction',
      description: 'Construction: Your Facility, Our Focus',
      image: '/Construction.png',
      path:'/construction'
    }
  ];

 const handleCardClick = (path) => {
  if (path.startsWith('http')) {
    window.open(path, '_blank'); // open external URL in new tab
  } else {
    navigate(path); // internal route
  }
};

  return (
  
    <div className="services-page">
      <div className="services-header">
        <h1>End To End Assistance</h1>
        <div className="underline"></div>
      </div>

      <div className="services-container">
        {/* First row with 5 services */}
        <div className="services-row">
          {services.slice(0, 5).map((service, index) => (
            <div 
              className="service-card"
              key={`service-${index}`}
              data-aos="fade-up"
              onClick={() => handleCardClick(service.path)}
            >
              <img src={service.image} alt={service.title} className="service-image" />
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <div className="arrow">→</div>
            </div>
          ))}
        </div>
        
        {/* Second row with remaining services */}
        <div className="services-row">
          {services.slice(5).map((service, index) => (
            <div 
              className="service-card"
              key={`service-${index+5}`}
              data-aos="fade-up"
              data-aos-delay={index * 100} // Staggered animation
              onClick={() => handleCardClick(service.path)}
            >
              <img src={service.image} alt={service.title} className="service-image" />
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <div className="arrow">→</div>
            </div>
          ))}
        </div>
      </div>
    </div>


  );
}

export default Services;